


















































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import ProductIssueState from '@/components/Products/ProductIssues/ProductIssueState.vue';
import ProductIssueEditDialog from '@/components/Products/ProductIssues/ProductIssueEditDialog.vue';

@Component({ name: 'ProductIssueDetails', components: { ProductIssueState, ProductIssueEditDialog } })
export default class extends SaascadaVue {

    get productIssue() {
        return ProductIssueDetailsModule.productIssue;
    }

}
